export const getContractProducts = (
  { contractNumber, systemUserId }
) => ({
  type: "GET_CONTRACT_PRODUCTS",
  payload: {
    contractNumber,
    systemUserId,
  },
});
export const getContractProductsSuccess = (data) => ({
  type: "GET_CONTRACT_PRODUCTS_SUCCESS",
  payload: data,
});
export const getContractProductsFailure = (error) => ({
  type: "GET_CONTRACT_PRODUCTS_FAILURE",
  payload: error,
});

export const getAvaliableProducts = ({ eventId, contractNumber }) => ({
  type: "GET_PRODUCTS_TO_CART",
  payload: {
    eventId,
    contractNumber,
  },
});
export const getAvaliableProductsSuccess = (data) => ({
  type: "GET_PRODUCTS_TO_CART_SUCCESS",
  payload: data,
});
export const getAvaliableProductsFailure = (error) => ({
  type: "GET_PRODUCTS_TO_CART_FAILURE",
  payload: error,
});

export const updateAvaliableProducts = ({ products, cart }) => ({
  type: "UPDATE_PRODUCTS_TO_CART",
  payload: {
    products,
    cart,
  },
});

export const checkoutInfo = ({ data }) => ({
  type: "CHECKOUT_INFO",
  payload: {
    data,
  },
});

export const purchaseInfo = ({ data }) => ({
  type: "SAVE_PURCHASE_INFO",
  payload: {
    data,
  },
});

export const resetSaleInfo = () => ({
  type: "RESET_SALE_INFO",
});

export const resetSaleInfoSuccess = () => ({
  type: "RESET_SALE_INFO_SUCCESS",
});

export const getContractInfo = ({ serviceOpportunityNumber }) => ({
  type: "GET_CONTRACT_INFO",
  payload: {
    serviceOpportunityNumber,
  },
});
export const getContractInfoSuccess = (data) => ({
  type: "GET_CONTRACT_INFO_SUCCESS",
  payload: data,
});
export const getContractInfoFailure = (error) => ({
  type: "GET_CONTRACT_INFO_FAILURE",
  payload: error,
});

// Action que retorna Promise para usar com await
export const getContractInfoAsync = ({ serviceOpportunityNumber }) => ({
  type: "GET_CONTRACT_INFO_ASYNC",
  payload: {
    serviceOpportunityNumber,
  },
});

// Function que cria uma Promise para usar com dispatch e await
export const createContractInfoPromise = (
  dispatch,
  { serviceOpportunityNumber }
) => {
  return new Promise((resolve, reject) => {
    dispatch({
      type: "GET_CONTRACT_INFO_ASYNC",
      payload: { serviceOpportunityNumber },
      resolve,
      reject,
    });
  });
};

export function getEventList() {
  return {
    type: "GET_EVENT_LIST_CAEX",
  };
}

export function getEventListSuccess({ events }) {
  return {
    type: "GET_EVENT_LIST_SUCCESS",
    payload: { events },
  };
}

export function getEventListFailure(error) {
  return {
    type: "GET_EVENT_LIST_FAILURE",
    payload: error,
  };
}

export function getStaffAttendenceInfo(params) {
  return {
    type: "GET_STAFF_ATTENDENCE_INFO",
    payload: params,
  };
}

export function getStaffAttendenceInfoSuccess({ metrics }) {
  return {
    type: "GET_STAFF_ATTENDENCE_INFO_SUCCESS",
    payload: { metrics },
  };
}

export function getStaffAttendenceInfoFailure(error) {
  return {
    type: "GET_STAFF_ATTENDENCE_INFO_FAILURE",
    payload: error,
  };
}

export function getStaffAttendenceTableInfo(params) {
  return {
    type: "GET_STAFF_ATTENDENCE_TABLE",
    payload: params,
  };
}

export function getStaffAttendenceTableInfoSuccess({ staffData, pageInfo }) {
  return {
    type: "GET_STAFF_ATTENDENCE_TABLE_SUCCESS",
    payload: { staffData, pageInfo },
  };
}

export function getStaffAttendenceTableInfoFailure(error) {
  return {
    type: "GET_STAFF_ATTENDENCE_TABLE_FAILURE",
    payload: error,
  };
}

export const RESET_STAFF_ACCESS = "RESET_STAFF_ACCESS";

export const resetStaffAccess = () => ({
  type: RESET_STAFF_ACCESS,
});
